import { useEffect, useState } from "react";

export const PLATFORM_BREAKPOINTS = Object.freeze({
  tablet: 768,
  desktop: 1024,
});

export const PLATFORM_NAMES = Object.freeze({
  mobile: "mobile",
  tablet: "tablet",
  desktop: "desktop",
});

const readWindowWidth = () => {
  if (typeof window === "undefined") return null;
  const viewportWidth = window.visualViewport?.width;
  if (Number.isFinite(viewportWidth) && viewportWidth > 0) return viewportWidth;
  const innerWidth = window.innerWidth;
  if (Number.isFinite(innerWidth) && innerWidth > 0) return innerWidth;
  return null;
};

export const resolvePlatformFromWidth = (width) => {
  const numericWidth = Number(width);
  if (!Number.isFinite(numericWidth) || numericWidth <= 0) return PLATFORM_NAMES.mobile;
  if (numericWidth >= PLATFORM_BREAKPOINTS.desktop) return PLATFORM_NAMES.desktop;
  if (numericWidth >= PLATFORM_BREAKPOINTS.tablet) return PLATFORM_NAMES.tablet;
  return PLATFORM_NAMES.mobile;
};

const getInitialPlatform = () => resolvePlatformFromWidth(readWindowWidth());

export default function usePlatform() {
  const [platform, setPlatform] = useState(getInitialPlatform);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const updatePlatform = () => {
      const nextPlatform = resolvePlatformFromWidth(readWindowWidth());
      setPlatform((currentPlatform) => (
        currentPlatform === nextPlatform ? currentPlatform : nextPlatform
      ));
    };

    updatePlatform();
    window.addEventListener("resize", updatePlatform);
    window.visualViewport?.addEventListener("resize", updatePlatform);

    return () => {
      window.removeEventListener("resize", updatePlatform);
      window.visualViewport?.removeEventListener("resize", updatePlatform);
    };
  }, []);

  return platform;
}
